/**
 * AUTO-GENERATED - DO NOT EDIT MANUALLY
 *
 * This file is generated from the browserslist configuration.
 * To update: npm run generate-supported-browsers
 * Verification: npm run check:supported-browsers
 */
export const supportedBrowsersRegex =
  /Edge?\/(14\d|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(14[2-9]|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(14\d|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(18\.([5-9]|\d{2,})|(19|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\//;
